import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useMinistries, useMinistryPosts } from '../services';
import { colors } from '../utils';
import { Box, Card, CardContent, CardMedia } from '@mui/material';
import Seo from './Seo';

const MinistryDetails = () => {
  const { id } = useParams();
  const { ministries } = useMinistries();
  const ministry = ministries.find((x) => x.id === id);
  const { posts } = useMinistryPosts(id || '');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (!ministry || !ministry.media || ministry.media.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentImageIndex(
        (prevIndex) => (prevIndex + 1) % ministry.media.length
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [ministry]);

  if (!ministry) return null;
  return (
    <div className="ministry-details">
      <Seo
        title={ministry.name}
        description={
          ministry.description ||
          `Learn more about the ${ministry.name} ministry at New Mt. Zion Missionary Baptist Church in Lakeland, FL.`
        }
        path={`/ministries/${ministry.id}`}
      />
      <div className="ministry-details-name" style={{ textAlign: 'center' }}>
        {ministry.name}
      </div>
      {ministry.media && ministry.media.length > 0 && (
        <img
          src={
            ministry.media[currentImageIndex].startsWith('http')
              ? ministry.media[currentImageIndex]
              : require(`../images/ministries/${ministry.media[currentImageIndex]}`)
          }
          className="ministry-details-image"
          alt={ministry.name}
        />
      )}
      <Box
        sx={{
          width: { xs: '100%', md: '80%' },
        }}
      >
        {ministry.passage && (
          <div
            style={{
              color: colors.themeRed,
              fontWeight: 'normal',
              fontSize: '1.3rem',
              padding: '1rem',
            }}
          >
            {ministry.passage}
          </div>
        )}
        {ministry.description && (
          <div
            style={{
              margin: '1rem',
              color: '#616161',
              fontSize: '1.2rem',
              lineHeight: '1.6',
            }}
          >
            {ministry.description}
          </div>
        )}
        {ministry.leaders && (
          <div
            style={{
              margin: '1rem',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              color: '#424242',
            }}
          >
            Leaders: {ministry.leaders}
          </div>
        )}
        {ministry.content && (
          <div
            dangerouslySetInnerHTML={{ __html: ministry.content }}
            style={{ margin: '1rem', color: '#616161', fontSize: '1.3rem' }}
          ></div>
        )}
        {posts.length > 0 && (
          <div style={{ margin: '1rem', marginTop: '2rem' }}>
            <div
              style={{
                fontSize: '1.4rem',
                fontWeight: 'bold',
                color: '#424242',
                marginBottom: '1rem',
              }}
            >
              Posts
            </div>
            {posts.map((post) => (
              <Card key={post.id} sx={{ marginBottom: 2 }}>
                {post.imageUrl && (
                  <CardMedia
                    component="img"
                    height="200"
                    image={post.imageUrl}
                    alt={post.title}
                  />
                )}
                <CardContent>
                  <div
                    style={{
                      fontSize: '1.2rem',
                      fontWeight: 'bold',
                      color: '#424242',
                    }}
                  >
                    {post.title}
                  </div>
                  <div
                    style={{
                      fontSize: '0.85rem',
                      color: '#999',
                      marginBottom: '0.5rem',
                    }}
                  >
                    {post.authorName} &middot;{' '}
                    {post.createdAt.toLocaleDateString()}
                  </div>
                  <div style={{ color: '#616161', fontSize: '1rem' }}>
                    {post.content}
                  </div>
                  {post.linkUrl && (
                    <a
                      href={post.linkUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: colors.themeRed, marginTop: '0.5rem', display: 'inline-block' }}
                    >
                      {post.linkLabel || post.linkUrl}
                    </a>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </Box>
    </div>
  );
};

export default MinistryDetails;
